<style lang="scss" scoped>
.picker {
	.el-tabs {
		& /deep/ .el-tab-pane {
			height: 400px;
			overflow-x: auto;
		}
		& /deep/ #tab-search {
			display: none;
		}
	}
	&__search {
		margin-bottom: 20px;
	}
}
</style>

<template lang="pug">
.picker
    loader(v-if='loading', :visible='true', message='Loading emojis...')
    div(v-else)
        el-input(type="text", v-model="local.search", placeholder="Search...", ref="search", autofocus="true").picker__search
            i(slot="prefix" class="el-input__icon el-icon-search")
        el-tabs(tab-position="left", style="height: 400px", v-model="local.selectedCategory")
            el-tab-pane(label="Search", name="search", lazy)
                emoji(v-for="emoji in results", :key="emoji.id" :id="emoji.id", @click="selectEmoji(emoji.id)")
            el-tab-pane(v-for="c in categories", :label="c.category_label", :key="c.category" :name="c.category" lazy)
                emoji(v-for="emoji in findEmojiByCategory(c.category)", :key="emoji.id", :id="emoji.id", @click="selectEmoji(emoji.id)")
</template>

<script>
import Fuse from "fuse.js";
import emojisList from "./picker/emoji.json";
import categories from "./picker/categories.json";
import Emoji from "./picker/Emoji";

export default {
	props: {
		value: {
			type: String,
			default: ""
		},
		selectedCategory: {
			type: String,
			default: "people"
		},
		search: {
			type: String,
			default: ""
		}
	},
	components: {
		Emoji
	},
	data() {
		const emojis = Object.keys(emojisList).map(id => ({
			...emojisList[id],
			id
		}));

		return {
			loading: true,
			local: {
				value: this.value,
				search: this.search,
				selectedCategory: this.selectedCategory
			},
			emojis,
			categories,
			fuse: new Fuse(emojis, {
				shouldSort: true,
				threshold: 0.6,
				location: 0,
				distance: 100,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: ["name", "alpha_code"]
			})
		};
	},
	computed: {
		results() {
			return this.local.search ? this.fuse.search(this.local.search).splice(0, 100) : [];
		}
	},
	mounted() {
		// Hacky solution - This allows the component to render and THEN load the emojis picker
		// This avoids the component not displaying for 1-3 seconds, but instead it'll display a loading message while it _tries_ to load the emojis
		setTimeout(() => (this.loading = false), 50);
	},
	watch: {
		"local.search"() {
			if (this.local.search !== "") {
				this.local.selectedCategory = "search";
			} else {
				this.local.selectedCategory = "people";
			}

			this.$emit("update:search", this.local.search);
		},
		"local.selectedCategory"() {
			if (this.local.selectedCategory !== "search") {
				this.local.search = "";
			}

			this.$emit("update:selectedCategory", this.local.selectedCategory);
		}
	},
	methods: {
		findEmojiByCategory(category) {
			return this.emojis.filter(emoji => emoji.category === category);
		},
		selectEmoji(emoji) {
			this.local.value = emoji;

			this.$emit("input", this.local.value);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/emojis/Picker.vue